export const isLocal = () => window.location.origin.includes('localhost');
export const COOKIE_DOMAIN = isLocal() ? '.localhost.local' : '.docs.netomi.com';

export const GTM_ID_INTERNAL = 'GTM-PWDNDJG';
export const GTM_ID_EXTERNAL = 'GTM-5BH2PLS';
export const GA4_ID_PARTNER = 'G-4WJ0PE3H4R';
export const INTERNAL_PORTAL_URL = 'https://internal.docs.netomi.com';
export const EXTERNAL_PORTAL_URL = 'https://docs.netomi.com';
export const PARTNER_PORTAL_URL = 'https://partner.docs.netomi.com';
export const HOTJAR_ID_INTERNAL = '5218279';
export const HOTJAR_ID_EXTERNAL = '5218283';
export const HOTJAR_ID_LOCAL = '2628964';
export const SSO_LOGIN_URL_PROD = '/api/auth/sso/login';
export const SSO_LOGIN_URL_LOCAL = `https://localhost.local:5001/api/auth/sso/login`;
